import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { clearStorage, setSession } from "../../store/session/actions";
import Logo from "../../common/helper/Logo";
import { useAuth0 } from "@auth0/auth0-react";
import { fetchPermission } from "../../repo/user";
import {
  Box,
  Avatar,
  Button,
  CssBaseline,
  CircularProgress,
  Typography,
  Container,
} from "@mui/material";
import _, { get } from "lodash";
import { Fingerprint, FingerprintOutlined } from "@mui/icons-material";

const classes = {
  paper: {
    marginTop: 8,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: 1,
    backgroundColor: "var(--dmg-gray-400)",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: 1,
  },
  submit: {
    margin: "24px 0 16px",
  },
};
const useQuery = function () {
  const { search } = window.location;
  return React.useMemo(() => new URLSearchParams(search), [search]);
};
const inactiveTimeToLogout = parseInt(
  process.env.INACTIVE_TIME_TO_LOGOUT || "10"
);
export default function Auth0Login() {
  const query = useQuery();
  const dispatch = useDispatch();
  const { error, isAuthenticated, logout, user, getIdTokenClaims } = useAuth0();
  const { loginWithRedirect } = useAuth0();
  const history = useHistory();
  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };
  const [permissionState, setPermissionLoadedState] = useState("pending");

  useEffect(() => {
    if (isAuthenticated) {
      const getIdTokenClaimPromise = getIdTokenClaims();
      getIdTokenClaimPromise.then((accessToken) => {
        if (accessToken) {
          const userId = accessToken.sub;
          
          // Store token in sessionStorage for later blacklisting
          if (accessToken.__raw) {
            sessionStorage.setItem('access_token', accessToken.__raw);
            console.log('💾 Token stored in sessionStorage for blacklisting:', accessToken.__raw ? 'Yes' : 'No');
          }
          
          // get user permissions
          const sessionData = {
            meta: {
              token: accessToken.__raw,
            },
            data: [
              {
                id: accessToken.sub,
                attributes: {
                  Enabled: true,
                  Email: accessToken.email,
                  FirstName: accessToken.family_name,
                  Group: accessToken["https://datameshgroup.com.au/roles"],
                  LastName: accessToken.given_name,
                  PreferredName: accessToken.name,
                },
              },
            ],
            permission: {},
          } as any;
          dispatch(setSession(sessionData));
          fetchPermission(userId).then((result) => {
            // @ts-ignore
            const Permission =
              // @ts-ignore
              result.data?.length > 0
                ? // @ts-ignore
                  result.data[0].attributes?.Permission
                : undefined;
            const Group =
              // @ts-ignore
              result.data?.length > 0
                ? // @ts-ignore
                  result.data[0].attributes?.Group
                : undefined;
            if (!Permission || Object.keys(Permission).length === 0) {
              setPermissionLoadedState("error");
            } else {
              sessionData.permission = Permission;
              sessionData.data[0].attributes.Group = Group ?? sessionData.data[0].attributes.Group;
              setPermissionLoadedState("success");
              dispatch(setSession(sessionData));
              return history.push("/dashboard");
            }
          });
        }
      });
    } else {
      dispatch(clearStorage());
    }
  }, [isAuthenticated]);
  const handleLogin = async () => {
    await loginWithRedirect();
  };

  return (
    <Container component="main" maxWidth="xs" style={{ marginTop: '15%' }}>
      <CssBaseline />
      <Box sx={classes.paper}>
        <Logo />

        <h3>Terminal Management System</h3>

        <Avatar sx={classes.avatar}>
          <FingerprintOutlined style={{ color: 'white !important' }} />
        </Avatar>
        {!isAuthenticated && (
          <Button
            onClick={handleLogin}
            fullWidth
            variant="contained"
            color="primary"
            sx={classes.submit}
          >
            Sign In
          </Button>
        )}
        {query.get("logout_process") === "auto" && (
          <Typography align="center" color="error">
            You have been automatically logged out due to {inactiveTimeToLogout}{" "}
            minutes of inactivity.
          </Typography>
        )}
        {permissionState === "error" && (
          <Typography align="center" color="error">
            There was a problem with your login attempt, please contact support
          </Typography>
        )}
        {isAuthenticated && ["success", "error"].includes(permissionState) && (
          <Button
            fullWidth
            variant="contained"
            color="primary"
            sx={classes.submit}
            onClick={handleLogout}
          >
            Logout
          </Button>
        )}
        {isAuthenticated && permissionState === "pending" && (
          <CircularProgress color="secondary" />
        )}
      </Box>
    </Container>
  );
}
